import { BlogPost } from "data/types";
import React, { FC, useEffect, useState } from "react";
import Card3Small from "./PopularPostCard";
import WidgetHeading1 from "./WidgetHeading1";

export interface WidgetPostsProps {
  className?: string;
  popular?: BlogPost[];
  loading?: boolean;
}

const WidgetPosts: FC<WidgetPostsProps> = ({
  className = "border border-neutral-200 dark:border-neutral-700",
  popular: propPopular,
  loading: propLoading,
}) => {
  const [fetchedPopular, setFetchedPopular] = useState<BlogPost[]>([]);
  const [fetchLoading, setFetchLoading] = useState(propPopular === undefined);

  useEffect(() => {
    if (propPopular !== undefined) return;
    fetch(`${process.env.REACT_APP_API_URL}/posts/popular`)
      .then(r => r.json())
      .then(setFetchedPopular)
      .catch(err => console.error('Error fetching popular posts:', err))
      .finally(() => setFetchLoading(false));
  }, [propPopular]);

  const popular = propPopular ?? fetchedPopular;
  const loading = propLoading ?? fetchLoading;

  return (
    <div
      className={`nc-WidgetPosts rounded-2xl overflow-hidden ${className}`}
      data-nc-id="WidgetPosts"
    >
      <WidgetHeading1
        title="인기 글"
        viewAll={{ label: "전체보기", href: "/blog-list" }}
      />
      <div className="flex flex-col divide-y divide-neutral-200 dark:divide-neutral-700">
        {loading ? (
          [...Array(4)].map((_, i) => (
            <div key={i} className="p-4 xl:px-5 xl:py-6 animate-pulse flex gap-3">
              <div className="flex-1 space-y-2">
                <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded w-3/4" />
                <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded w-1/2" />
                <div className="h-3 bg-neutral-200 dark:bg-neutral-700 rounded w-2/3" />
              </div>
              <div className="w-16 h-12 bg-neutral-200 dark:bg-neutral-700 rounded-lg flex-shrink-0" />
            </div>
          ))
        ) : (
          popular.map((post) => (
            <Card3Small
              className="p-4 xl:px-5 xl:py-6 hover:bg-neutral-200 dark:hover:bg-neutral-700"
              key={post.id}
              post={post}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default WidgetPosts;
